import React from 'react';
import noAccountsIcon from '../../assets/icons/no-accounts-icon.svg';
import './NoAccountsFound.css';

interface NoAccountsFoundProps {
  onBack?: () => void;
}

const NoAccountsFound: React.FC<NoAccountsFoundProps> = ({ onBack }) => {
  return (
    <div className="no-accounts-found">
      <div className="no-accounts-container">
        {/* Icon */}
        <div className="no-accounts-icon-container">
          <img 
            src={noAccountsIcon} 
            alt="No accounts" 
            className="no-accounts-icon"
          />
        </div>

        {/* Content */}
        <div className="no-accounts-content">
          <div className="no-accounts-text">
            <h1 className="no-accounts-heading">No accounts found</h1>
            <p className="no-accounts-subtext">
              We couldn't find eligible accounts for cash credit through Open Banking. 
              You can try linking a different account or bank.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoAccountsFound;

